import { render } from "./QuizForm.vue?vue&type=template&id=90a23300"
import script from "./QuizForm.vue?vue&type=script&lang=js"
export * from "./QuizForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__